/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const t=e=>{var o;return!!(typeof e=="function"&&((o=e.prototype)!=null&&o.isReactComponent))},n=e=>!!(e.$$typeof&&typeof e.render=="function"),s=e=>typeof Comment!="string"&&(t(e)||n(e));exports.canUseRef=s;
